export const STATUS_FILTER_SET = 'at/taskManagement/STATUS_FILTER_SET'


// WEBPACK FOOTER //
// ./web/js/workflowStatus/components/statusFilter/actionTypes.js